export const PASSWORD_MIN_LENGTH = 8;

export const PASSWORD_MIN_LENGTH_ERROR =
  `La contraseña debe tener al menos ${PASSWORD_MIN_LENGTH} caracteres.`;

export function passwordCumpleLongitudMinima(password) {
  return typeof password === "string" && password.length >= PASSWORD_MIN_LENGTH;
}
